import React from 'react';
import '../../components/DBOSHomepage.css';
import '../SmartWeb.css';
import './Legal.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="container">
          <a href="/" className="logo">
            <span className="logo-text shimmering">DBOS.world</span>
          </a>
        </div>
      </header>
      <main className="legal-content">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="version-info">V1.0 | 03/03/2026</p>
          
          <section className="legal-section">
            <p>We respect your privacy and are committed to protecting your personal data in accordance with the General Data Protection Regulation (GDPR).</p>
          </section>

          <section className="legal-section">
            <h2>1. Data Controller</h2>
            <p className="provider-info">
              <strong>DBOS</strong><br/>
              (operating under Smart Trades Training, CRO No. 778363)<br/>
              Arvagh, Co. Cavan, Ireland<br/>
              Contact: <a href="mailto:support@dbos.world">support@dbos.world</a>
            </p>
          </section>

          <section className="legal-section">
            <h2>2. What Data We Collect</h2>
            <p>We may collect:</p>
            <ul>
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Company details</li>
              <li>Eircode (for Irish clients)</li>
              <li>Payment information (processed via secure third-party providers)</li>
              <li>Website usage data</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. How We Use Your Data</h2>
            <p>We process personal data to:</p>
            <ul>
              <li>Provide services</li>
              <li>Respond to inquiries</li>
              <li>Process payments</li>
              <li>Improve system performance</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Legal Basis</h2>
            <p>We process data based on: Contractual necessity, Legitimate interest, Legal obligations, and Consent (where required).</p>
          </section>

          <section className="legal-section">
            <h2>5. Data Sharing & Third-Party Tools</h2>
            <p>We may share data with trusted service providers:</p>
            <ul>
              <li>Hosting providers (Firebase, Google Cloud)</li>
              <li>Payment processors (Stripe)</li>
              <li>Analytics tools (Google Analytics, Microsoft Clarity)</li>
            </ul>
            <p>These tools collect anonymized usage data. Where required by GDPR, they are activated only upon your explicit consent.</p>
          </section>

          <section className="legal-section">
            <h2>6. Your Rights Under GDPR</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your data</li>
              <li>Request correction</li>
              <li>Request deletion</li>
              <li>Restrict processing</li>
              <li>Object to processing</li>
              <li>Data portability</li>
            </ul>
            <p>To exercise your rights, contact: <a href="mailto:support@dbos.world">support@dbos.world</a></p>
          </section>

          <section className="legal-section">
            <h2>7. Data Security</h2>
            <p>We implement appropriate technical and organizational measures to protect personal data from unauthorized access or misuse.</p>
          </section>

          <section className="legal-section">
            <h2>8. International Transfers</h2>
            <p>If data is transferred outside the EU/EEA, appropriate safeguards such as Standard Contractual Clauses are applied.</p>
          </section>

          <div className="legal-footer">
            <p><a href="/legal/terms">Terms</a> | <a href="/legal/cookies">Cookies</a> | <a href="/legal/dpa">DPA</a></p>
            <a href="/" className="btn-back">← Back to Home</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Privacy;
